module.exports = __webpack_public_path__ + "img/doctrine-1.351da5e0.jpg";